import { getConfig } from "@util/config";

export const API_URL: string = getConfig("API_HOST");

export const API_REQUEST_EXPIRATION: number = 30000;

export const API_REQUEST: string = "Api/REQUEST";
export const API_REQUEST_PROGRESS: string = "Api/REQUEST_PROGRESS";
export const API_REQUEST_EXPIRE: string = "Api/REQUEST_EXPIRE";
export const API_RESPONSE_SUCCESS: string = "Api/RESPONSE_SUCCESS";
export const API_RESPONSE_FAILURE: string = "Api/RESPONSE_FAILURE";
